import {useSelector} from "react-redux";
import {OtsUIState} from "@ots-frontend/ots-ui";

export function useOtsUISelector<T>(
  selector: (state: OtsUIState) => T,
  equalityFn?: (left: T, right: T) => boolean
) {
  return useSelector(selector, equalityFn);
}
